/* eslint-disable camelcase */
// @TODO - Prevent this from causing loading from showing

window.cb_storeprefonserver = function cb_storeprefonserver(data) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(data.pannel_id, data);
};

window.storePrefOnServer = function storePrefOnServer(name, pref, value, panelId) {
  const content_map = {} as ContentMap;
  content_map.form_name = 'setpref';
  content_map.name = name;
  content_map.pref = pref;
  content_map.value = value;
  content_map.pannel_id = panelId;
  window.doServerCall(content_map, window.cb_storeprefonserver);
};
